const ChatAi = "ChatAi";
const ShowMenuAi = "ShowMenuAi";
const UniqueId = "UniqueId";
const Model = "Model";
const NewChat = "NewChat";

const state = {
  [ChatAi]: [],
  [ShowMenuAi]: false,
  [UniqueId]: null,
  [Model]: null,
  [NewChat]: false,
};

const getters = {
  [ChatAi](state) {
    return state[ChatAi];
  },
  [ShowMenuAi](state) {
    return state[ShowMenuAi];
  },
  [UniqueId](state) {
    return state[UniqueId];
  },
  [ChatAi](state) {
    return state[ChatAi];
  },
  [NewChat](state) {
    return state[NewChat];
  },
};

const mutations = {
  setShow(state, value) {
    state[ShowMenuAi] = value;
  },
  setChat(state, value) {
    state[ChatAi] = value;
  },
  setUniqueId(state, value) {
    state[UniqueId] = value;
  },
  setModle(state, value) {
    state[Model] = value;
  },
  setNewChat(state, value) {
    state[NewChat] = value;
  },
};

const actions = {
  setShow({ commit, state }) {
    commit("setShow", !state[ShowMenuAi]);
  },
  setChat({ commit }, value) {
    commit("setChat", value);
  },
  setUniqueId({ commit }, value) {
    commit("setUniqueId", value);
  },
  setModle({ commit }, value) {
    commit("setModle", value);
  },
  setNewChat({ commit }, value) {
    commit("setNewChat", !state[NewChat]);
  },
};

export default {
  namespaced: true,
  actions,
  getters,
  state,
  mutations,
};
